import QueryState from '../query_state'
import Sidebar from '../sidebar'
import TopBar from '../top_bar'
import useAuth from '../../hooks/use_auth'
import { Outlet, useLocation } from 'react-router-dom'

function AirlineCycleWrapper() {
  const { user, isLoading: isUserLoading, logOut } = useAuth()
  const accountSettings = useLocation().pathname.startsWith('/settings/account')

  return (
    <>
      <QueryState isLoading={isUserLoading || logOut.isLoading} loadingClassName='h-screen'>
        <div className='flex h-dvh w-screen overflow-hidden'>
          {user ? <Sidebar user={user} logOut={logOut} /> : null}
          <div className='flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden'>
            {accountSettings ? null : <TopBar />}
            <div
              className={`min-h-0 min-w-0 flex-1 overflow-auto overscroll-none px-4 pb-16 lg:px-16 ${accountSettings ? 'pt-16' : 'pt-1'}`}
            >
              <div className='cs-page-frame'>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </QueryState>
    </>
  )
}

export default AirlineCycleWrapper
